import { GridFilterModel, GridPaginationModel, GridSortModel } from '@mui/x-data-grid-pro';

import { serializeFilterModel, serializePagination, serializeSortModel } from './serializers';

// Utility to build query string from state
export function buildQueryString({
  paginationModel,
  sortModel,
  filterModel,
  serializeDateFilterValues = false,
}: {
  paginationModel?: GridPaginationModel;
  sortModel?: GridSortModel;
  filterModel?: GridFilterModel;
  additionalQueryArgs?: string;
  /** Serialize Date filter values as ISO dates (see serializeFilterModel). */
  serializeDateFilterValues?: boolean;
}) {
  const serializedPaginationModel = serializePagination(paginationModel);
  const serializedSortModel = serializeSortModel(sortModel);
  const serializedFilterModel = serializeFilterModel(filterModel, serializeDateFilterValues);

  const params = new URLSearchParams();
  serializedPaginationModel && params.set('page', (serializedPaginationModel.page + 1).toString());
  serializedPaginationModel &&
    params.set('pageSize', serializedPaginationModel.pageSize.toString());
  serializedSortModel && params.set('sort', serializedSortModel);
  serializedFilterModel?.filter && params.set('filter', serializedFilterModel.filter);
  serializedFilterModel?.logicOperator &&
    params.set('logicOperator', serializedFilterModel.logicOperator || 'and');
  // quickFilterValues joins to a non-empty but whitespace-only string for inputs such as
  // ['', ''] or ['\t']. Omit the param in that case so a whitespace-only quick filter
  // leaves the query string byte-identical to no quick filter at all.
  if (serializedFilterModel?.quickFilter && serializedFilterModel.quickFilter.trim()) {
    params.set('quickFilter', serializedFilterModel.quickFilter);
  }
  serializedFilterModel?.quickFilterLogicOperator &&
    params.set('quickFilterLogicOperator', serializedFilterModel.quickFilterLogicOperator || 'and');

  return params.toString();
}
